import { render, staticRenderFns } from "./common-add-content.vue?vue&type=template&id=66e712b9&scoped=true"
import script from "./common-add-content.vue?vue&type=script&lang=js"
export * from "./common-add-content.vue?vue&type=script&lang=js"
import style0 from "./common-add-content.vue?vue&type=style&index=0&id=66e712b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e712b9",
  null
  
)

export default component.exports